/**
 * sky-discount-bridge.js
 *
 * Wires the visible toggles inside sections/sky-product-hero.liquid onto the
 * API exposed by assets/sky-discount-system.js. The bridge:
 *
 *   1. Restores the active state of [data-assembly="self"|"pro"] from
 *      localStorage.assemblyPreference on load.
 *   2. Routes click events on [data-assembly] through
 *      window.handleDiscountButtonClick so the discount system can
 *      recalculate prices, sync the cart, and update the checkout URL.
 *   3. Restores the active state of [data-grp="bau"] from
 *      localStorage.cartArchitectSelected on load.
 *   4. Routes click events on [data-grp="bau"] through the architect
 *      localStorage flags + window.syncArchitectInCart.
 *
 * No DOM is created or removed; only class toggles + localStorage writes.
 */
(function () {
  "use strict";

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function syncAssemblyButtons(pref) {
    $$('[data-assembly]').forEach(function (b) {
      var mode = b.getAttribute('data-assembly');
      var match = (mode === 'self' && pref === 1) || (mode === 'pro' && pref === 2);
      b.classList.toggle('active', match);
    });
  }

  function bindAssemblyToggles() {
    $$('[data-assembly]').forEach(function (btn) {
      if (btn.dataset.skyBridgeBound) return;
      btn.dataset.skyBridgeBound = '1';
      btn.addEventListener('click', function () {
        var num = (btn.getAttribute('data-assembly') === 'pro') ? 2 : 1;
        var target = document.getElementById('discount-button-' + num);
        if (!target) return;
        if (typeof window.handleDiscountButtonClick === 'function') {
          var title = target.getAttribute('data-discount-title') || '';
          window.handleDiscountButtonClick(title, target);
        }
        syncAssemblyButtons(num);
      });
    });
  }

  function syncBaugesuchButtons(wantArchitect) {
    var btns = $$('[data-grp="bau"]');
    if (btns.length < 2) return;
    btns[0].classList.toggle('active', !wantArchitect);
    btns[1].classList.toggle('active', wantArchitect);
  }

  function bindBaugesuchToggles() {
    var btns = $$('[data-grp="bau"]');
    if (btns.length < 2) return;
    btns.forEach(function (btn, idx) {
      if (btn.dataset.skyBridgeBound) return;
      btn.dataset.skyBridgeBound = '1';
      btn.addEventListener('click', function () {
        var wantArchitect = (idx === 1);
        try { localStorage.setItem('cartArchitectSelected', wantArchitect ? 'true' : 'false'); } catch (e) {}

        var anchor = document.querySelector('[data-architect-variant-id]');
        if (anchor) {
          try {
            var vid = anchor.getAttribute('data-architect-variant-id');
            if (vid) localStorage.setItem('architectVariantId', vid);
            var eligible = anchor.getAttribute('data-architect-eligible-products') || '[]';
            localStorage.setItem('architectEligibleProducts', eligible);
          } catch (e) {}
        }

        syncBaugesuchButtons(wantArchitect);

        if (typeof window.syncArchitectInCart === 'function') {
          window.syncArchitectInCart(function () {
            try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
          });
        }
      });
    });
  }

  function registerArchitectEligibility() {
    var anchor = document.querySelector('[data-architect-variant-id]');
    if (!anchor) return;
    try {
      var vid = anchor.getAttribute('data-architect-variant-id');
      if (vid && !localStorage.getItem('architectVariantId')) {
        localStorage.setItem('architectVariantId', vid);
      }
      var rawList = anchor.getAttribute('data-architect-eligible-products') || '[]';
      var fromAnchor = JSON.parse(rawList);
      if (!Array.isArray(fromAnchor)) return;
      var existing = [];
      try {
        var raw = localStorage.getItem('architectEligibleProducts') || '[]';
        existing = JSON.parse(raw);
        if (!Array.isArray(existing)) existing = [];
      } catch (e) { existing = []; }
      var changed = false;
      fromAnchor.forEach(function (id) {
        var s = String(id);
        if (existing.indexOf(s) === -1 && existing.indexOf(id) === -1) {
          existing.push(s);
          changed = true;
        }
      });
      if (changed) {
        localStorage.setItem('architectEligibleProducts', JSON.stringify(existing));
      }
    } catch (e) {}
  }

  function tagVariantInput() {
    // sky-discount-system.js's buildForValue() reads from `.js-product-variant-id-input`
    // and looks up the variant-for-values-* JSON by its value. The new sky-product-hero
    // form input doesn't carry that class — without it the "Für" property on auto-added
    // Montage/Versandkosten line items would be empty, which breaks de-duplication during
    // syncMontageInCart / syncShippingInCart (empty `Für` is ignored by the existing-items
    // index and the sync ends up adding a duplicate). Add the class to bridge that gap.
    var forms = document.querySelectorAll('form[action*="/cart/add"], form.sky-cart-form');
    for (var i = 0; i < forms.length; i++) {
      var input = forms[i].querySelector('input[name="id"]:not(.js-product-variant-id-input)');
      if (input) input.classList.add('js-product-variant-id-input');
    }
  }

  function init() {
    // Hide the bridge's hidden discount-buttons even if a global rule tries to
    // show .discount-button — defensive belt-and-suspenders.
    var hidden = document.querySelectorAll('[data-sky-discount-bridge] .discount-button');
    for (var i = 0; i < hidden.length; i++) hidden[i].style.display = 'none';

    tagVariantInput();

    var pref = 1;
    if (typeof window.getAssemblyPreference === 'function') {
      try { pref = window.getAssemblyPreference(); } catch (e) {}
    } else {
      try { pref = parseInt(localStorage.getItem('assemblyPreference') || '1', 10) || 1; } catch (e) {}
    }
    syncAssemblyButtons(pref);
    bindAssemblyToggles();

    registerArchitectEligibility();
    var wantArchitect = false;
    try { wantArchitect = localStorage.getItem('cartArchitectSelected') === 'true'; } catch (e) {}
    syncBaugesuchButtons(wantArchitect);
    bindBaugesuchToggles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after Section Rendering API updates (theme editor reloads, AJAX swaps).
  document.addEventListener('shopify:section:load', init);
})();
